// src/components/GameBoard.jsx
import React, { useContext } from 'react';
import { GameContext } from '../context/GameContext';
import Scoreboard from './Scoreboard';
import PlayerHand from './PlayerHand';
import BiddingPhase from './BiddingPhase';
import TrumpSelector from './TrumpSelector';
import TrickBoard from './TrickBoard';
import CircularTrickBoard from './CircularTrickBoard';
import TurnIndicator from './TurnIndicator';
import GameSummary from './GameSummary';
import RoundPoints from './RoundPoints';
import HexagonalGameLayout from './HexagonalGameLayout';

const GameBoard = () => {
  const { gameState, socket, playerId } = useContext(GameContext);
  const phase = gameState?.state?.phase;

  // White background for lobby, bidding, trump selection
  // Green felt for play phase
  const backgroundColor = phase === 'play'
    ? 'linear-gradient(135deg, #1e5a3e 0%, #2d7a4f 50%, #1e5a3e 100%)'
    : 'white';

  return (
    <>
      <style>{`
        @keyframes trumpBounce {
          0% {
            transform: scale(0.5) translateY(-50px);
            opacity: 0;
          }
          60% {
            transform: scale(1.05) translateY(0);
            opacity: 1;
          }
          100% {
            transform: scale(1) translateY(0);
            opacity: 1;
          }
        }
        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
            box-shadow: 0 6px 12px rgba(0,0,0,0.4);
          }
          50% {
            transform: scale(1.05);
            box-shadow: 0 8px 16px rgba(220,38,38,0.6);
          }
        }
      `}</style>
    <div style={{
      padding: phase === 'play' ? '0' : '12px',
      maxWidth: '100%',
      minHeight: '100vh',
      background: backgroundColor
    }}>
      {/* Only show scoreboard after game starts */}
      {phase && phase !== 'lobby' && <Scoreboard />}

      {phase === 'bidding' && (
        <div style={{ padding: '8px' }}>
          <BiddingPhase />
        </div>
      )}

      {phase === 'trump-selection' && (
        <div style={{ padding: '8px' }}>
          <TrumpSelector />
        </div>
      )}

      {phase === 'play' && (
        <HexagonalGameLayout />
      )}

      {phase === 'results' && (
        <div style={{ padding: '8px' }}>
          <GameSummary />
        </div>
      )}
    </div>
    </>
  );
};

export default GameBoard;
